import(/* webpackMode: "eager" */ "/home/runner/work/accounts/accounts/frontend/app/login/login.tsx");
import(/* webpackMode: "eager" */ "/home/runner/work/accounts/accounts/frontend/src/component/auth-route.tsx")